/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Constants for optimizely-middleware
 */
export const TRACK = '@@zumper/optimizely-middleware/TRACK'
export const ACTIVATE = '@@zumper/optimizely-middleware/ACTIVATE'
